'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomTagSelectFacet = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ajaxCollectionV = require('@process-creative/ajax-collection-v3');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPTION = '[data-option]';
var DROPDOWN_EXPAND_TOGGLE = '[data-dropdown-expand-toggle]';
var OPTIONS_DROPDOWN = '[data-options-dropdown]';

var IS_EXPANDED = 'is-expanded';
var IS_SELECTED = 'is-selected';

var CustomTagSelectFacet = exports.CustomTagSelectFacet = function (_SmartTagFacet) {
  (0, _inherits3.default)(CustomTagSelectFacet, _SmartTagFacet);

  function CustomTagSelectFacet(params) {
    (0, _classCallCheck3.default)(this, CustomTagSelectFacet);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomTagSelectFacet.__proto__ || Object.getPrototypeOf(CustomTagSelectFacet)).call(this, params));

    _this.container.on('click', OPTION, function (e) {
      return _this.optionSelected(e);
    });
    _this.container.on('click', DROPDOWN_EXPAND_TOGGLE, function (e) {
      return _this.toggleExpandDropdown(e);
    });

    _this.isExpanded = false;

    return _this;
  }

  (0, _createClass3.default)(CustomTagSelectFacet, [{
    key: 'getPrint',
    value: function getPrint(e) {
      var _this2 = this;

      var options = this.getOptionsToDraw();
      var activeOption = options.find(function (o) {
        return _this2.isSelected(o);
      });

      var dropdownOptions = options.filter(function (o) {
        return !_this2.isSelected(o);
      });

      var elem_activeOption = '\n      <button class=\'c-tag-facet-custom-select__option ' + IS_SELECTED + '\' data-dropdown-expand-toggle>\n        ' + this.getOptionName(activeOption).trim() + '<icon class=\'c-tag-facet-custom-select__option-icon\'></icon>\n      </button>\n    ';
      var elem_dropdownOptions = void 0;
      if (dropdownOptions.length) {
        elem_dropdownOptions = '\n        <div class=\'c-tag-facet-custom-select__options-dropdown ' + (this.isExpanded ? IS_EXPANDED : '') + '\' data-options-dropdown>\n          ' + dropdownOptions.reduce(function (output, o) {
          return output + ('\n            <button class=\'c-tag-facet-custom-select__option\' data-option=\'' + o + '\'>\n              ' + _this2.getOptionName(o) + '\n            </button>\n          ');
        }, '') + '\n        </div>\n      ';
      }
      return '\n      <span class=\'c-tag-facet-custom-select\'>\n        ' + elem_activeOption + '\n        ' + (elem_dropdownOptions || '') + '\n      </span>\n    ';
    }
  }, {
    key: 'optionSelected',
    value: function optionSelected(e) {
      var self = $(e.currentTarget);
      var option = self.attr('data-option');
      this.setOptions([option]);
    }
  }, {
    key: 'toggleExpandDropdown',
    value: function toggleExpandDropdown(e) {
      e.stopPropagation();
      this.isExpanded = !this.isExpanded;
      var optionsDropdown = this.container.find(OPTIONS_DROPDOWN);

      if (this.isExpanded) {
        optionsDropdown.addClass(IS_EXPANDED);
        this.setBodyClickListener();
      } else {
        optionsDropdown.removeClass(IS_EXPANDED);
        this.turnOffBodyClickListener();
      }
    }
  }, {
    key: 'setBodyClickListener',
    value: function setBodyClickListener() {
      var _this3 = this;

      this.bodyClickListener = $('body').on('click touched', function (e) {
        _this3.toggleExpandDropdown(e);
        _this3.turnOffBodyClickListener();
      });
    }
  }, {
    key: 'turnOffBodyClickListener',
    value: function turnOffBodyClickListener() {
      this.bodyClickListener && this.bodyClickListener.off('click touched');
    }
  }]);
  return CustomTagSelectFacet;
}(_ajaxCollectionV.SmartTagFacet);